import { z } from "zod";
/**
 * Analise do checkout (spec 062, fase 1). A pagina do checkout conta cada passo pro `pagamentos`, sem dado pessoal: quem
 * e a pessoa so aparece a partir da tentativa, que ja e dela. O `visitante` e um codigo aleatorio guardado no navegador,
 * so pra ligar os passos de uma mesma visita (e a tentativa que nasce dela).
 */
export const NOMES_DE_EVENTO_DO_CHECKOUT = [
    /** Abriu a pagina. `dados.logado`: ja chegou com a conta aberta. */
    "aberto",
    /** A pagina pediu "Entrar ou criar conta" (chegou sem conta). */
    "conta_pedida",
    "entrou",
    "criou_conta",
    /** Marcou o regulamento (todas as caixas). */
    "regulamento_aceito",
    /** Aplicou um cupom. `dados.resultado`: "aplicado" ou "recusado"; `dados.motivo`: a frase que a pessoa viu. */
    "cupom",
    /** Uma mensagem de erro que a pessoa viu. `dados.etapa` (entrar, cadastro, pagar, cotacao) e `dados.mensagem`. */
    "erro",
    /** Saiu da pagina (fechou, voltou ou trocou de aba por muito tempo). `dados.passo` e `dados.segundos`. */
    "saiu",
];
export const Visitante = z.string().regex(/^[A-Za-z0-9_-]{16,40}$/, "visitante invalido");
/** De onde a pessoa veio: as UTMs do link e a pagina anterior (so o endereco, sem a parte depois do `?`). */
export const OrigemDaVisita = z.object({
    utm_source: z.string().trim().min(1).max(100).optional(),
    utm_medium: z.string().trim().min(1).max(100).optional(),
    utm_campaign: z.string().trim().min(1).max(150).optional(),
    utm_content: z.string().trim().min(1).max(150).optional(),
    utm_term: z.string().trim().min(1).max(100).optional(),
    pagina: z.string().trim().min(1).max(300).optional(),
});
const Valor = z.union([z.string().max(200), z.number().finite(), z.boolean()]);
/** `POST /v1/checkouts/:token/eventos`: um ou mais passos da mesma visita, com a hora do servidor. */
export const EventosDoCheckout = z.object({
    visitante: Visitante,
    /** So no `aberto` faz diferenca: e a origem que vale pra visita. */
    origem: OrigemDaVisita.optional(),
    eventos: z
        .array(z.object({
        nome: z.enum(NOMES_DE_EVENTO_DO_CHECKOUT),
        dados: z.record(z.string().max(30), Valor).refine((d) => Object.keys(d).length <= 8, "no maximo 8 campos").default({}),
    }))
        .min(1)
        .max(20),
});
/** Os passos do funil, em ordem. Quem chegou num passo conta em todos os anteriores (a pagina pode nao ter avisado). */
export const PASSOS_DO_FUNIL = [
    { chave: "abriu", rotulo: "Abriu o checkout" },
    { chave: "com_conta", rotulo: "Entrou na conta" },
    { chave: "aceitou", rotulo: "Aceitou o regulamento" },
    { chave: "clicou_pagar", rotulo: "Clicou em pagar" },
    { chave: "gerou_pagamento", rotulo: "Gerou o PIX ou tentou o cartão" },
    { chave: "pagou", rotulo: "Pagou" },
];
/**
 * Uso da area (spec 062, fase 2). A area manda um sinal por minuto so com a aba visivel e com movimento recente; o
 * backend soma por pessoa e por dia de Sao Paulo. `tela` e o primeiro pedaco do endereco ("inicio", "academy").
 */
export const SinalDeUso = z.object({ tela: z.string().regex(/^[a-z0-9-]{1,40}$/, "tela invalida") });
//# sourceMappingURL=analise.js.map